import {
  ExternalConnectionReturnChannel,
  ExternalConnectionsProviders,
} from '@griply/types';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type GetExternalConnectionAuthUrlPayload = {
  provider: ExternalConnectionsProviders;
  // Preselects the account on reconnect; consenting as another one creates a second connection.
  email?: string;
  returnChannel: ExternalConnectionReturnChannel;
};

export type GetExternalConnectionAuthUrlOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  payload: GetExternalConnectionAuthUrlPayload;
};

export const getExternalConnectionAuthUrl = async <TFunctions>(
  options: GetExternalConnectionAuthUrlOptions<TFunctions>,
): Promise<string> => {
  const { functions, httpsCallable, payload } = options;
  const callable = httpsCallable<GetExternalConnectionAuthUrlPayload, string>(
    functions,
    'externalConnections-getAuthenticationURL',
  );

  const { data } = await callable(payload);

  return data;
};
